export const shouldAutoStartWechatLogin = (search: string): boolean =>
  new URLSearchParams(search).get('social_login_failed') !== 'true';

const BLOCKED_ANONYMOUS_HOME_PATHS = /^\/(?:logout(?:\/|$)|auth(?:\/|$)|api\/sso\/discourse(?:\/|$))/;

export const resolveAnonymousHomeDestination = (
  landingPage: string,
  currentUrl: string,
): string => {
  try {
    const current = new URL(currentUrl);
    const landing = new URL(landingPage, current.origin);
    return landing.href === current.href || BLOCKED_ANONYMOUS_HOME_PATHS.test(landing.pathname)
      ? '/login'
      : landing.href;
  } catch {
    return '/login';
  }
};
